import { ReactNode, createContext, useContext, useState } from "react";
import { useLocation } from "react-router-dom";

interface BookInfContextType {
  items: HTMLLIElement[];
  setItems: (items: HTMLLIElement[]) => void;
  dates: string[];
  setDates: (dates: string[]) => void;
  dateRange: string[];
  setDateRange: (dateRange: string[]) => void;
  // rmCnt: number;
  // setRmCnt: (rmCnt: number) => void;
  // adltCnt: number;
  // setAdltCnt: (adltCnt: number) => void;
  // childCnt: number;
  // setChildCnt: (childCnt: number) => void;
  promCd: string;
  setPromCd: (promCd: string) => void;
  bkStep: number;
  setBkStep: (bkStep: number) => void;
  bookInf: any;
  // setBookInf: (rmInf: any) => void;
  isSearch: boolean;
  setIsSearch: (isSearch: boolean) => void;
  calendarOpen: string;
  setCalendarOpen: (calendarOpen: string) => void;
  userInf: uerInfProps;
  setUserInf: (userInf: any) => void;
  onBookInf(item: any): void;
  onUserInf(name: string, value: string): void;
  terms: any;
  onCheckBox(name: string, checked: boolean): void;
  onBkStep(step: number): void;
}

type uerInfProps = {
  cstFstnm: string;
  cstSurnm: string;
  emlId_1: string;
  emlId_2: string;
  emlId_3: string;
  cstEml: string;
  cstMblNo: string;
  cstMblCntyCd: string;
  reqCn: string;
};

export const BookInfContext = createContext<BookInfContextType | undefined>(
  undefined
);

interface IBookInfProvider {
  children: ReactNode;
}

export const BookInfProvider = ({ children }: IBookInfProvider) => {
  const { pathname } = useLocation();

  const [items, setItems] = useState<HTMLLIElement[]>([]); // 달력의 LIELEMENT LIST
  const [dates, setDates] = useState<string[]>(() => {
    const dates = localStorage.getItem("dates");
    if (dates) {
      return JSON.parse(dates);
    }
    return [];
  });
  const [dateRange, setDateRange] = useState<string[]>([]);

  const [promCd, setPromCd] = useState("");
  const [bkStep, setBkStep] = useState(() => {
    const step = localStorage.getItem("bkStep");
    if (step) {
      return JSON.parse(step);
    }

    return 1;
  });
  const [bookInf, setBookInf] = useState<any | null>(() => {
    const inf = localStorage.getItem("bookInf");

    if (inf && pathname.includes("book")) {
      return JSON.parse(inf);
    }
    return {
      dates: [],
      dateRange: [],
    };
  });
  const [isSearch, setIsSearch] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState("");

  const [userInf, setUserInf] = useState<uerInfProps>(() => {
    const bkUserInf = localStorage.getItem("bkUserInf");
    if (bkUserInf) {
      return JSON.parse(bkUserInf);
    }

    return {
      cstFstnm: "",
      cstSurnm: "",
      emlId_1: "",
      emlId_2: "",
      emlId_3: "",
      cstEml: "",
      cstMblNo: "",
      cstMblCntyCd: "+82",
      reqCn: "",
    };
  });

  const [terms, setTemrs] = useState<any>(() => {
    const term = localStorage.getItem("terms");
    if (term) {
      return JSON.parse(term);
    }

    return {
      all: false,
      "01": false,
      "02": false,
      "03": false,
      "04": false,
    };
  });

  const onBkStep = (step: number) => {
    setBkStep(step);
    localStorage.setItem("bkStep", bkStep + "");
  };

  const onUserInf = (name: string, value: string) => {
    setUserInf({
      ...userInf,
      [name]: value,
    });
    localStorage.setItem(
      "bkUserInf",
      JSON.stringify({
        ...userInf,
        cstMblCntyCd: name.includes("CntyCd") ? value : "+82",
        [name]: value,
      })
    );
  };

  const onBookInf = (item: any) => {
    localStorage.setItem(
      "bookInf",
      JSON.stringify({
        ...bookInf,
        ...item,
      })
    );

    setBookInf({
      ...bookInf,
      ...item,
    });
  };

  const onCheckBox = (name: string, checked: boolean) => {
    if (name === "all") {
      setTemrs({
        all: checked,
        "01": checked,
        "02": checked,
        "03": checked,
        "04": checked,
      });
      localStorage.setItem(
        "terms",
        JSON.stringify({
          all: checked,
          "01": checked,
          "02": checked,
          "03": checked,
          "04": checked,
        })
      );
      return;
    }
    if (name !== "all") {
      const newTerm = { ...terms, [name]: checked };
      let isAllCheck =
        newTerm["01"] && newTerm["02"] && newTerm["03"] && newTerm["04"];
      setTemrs({ ...terms, [name]: checked, all: isAllCheck });
      localStorage.setItem(
        "terms",
        JSON.stringify({ ...terms, [name]: checked, all: isAllCheck })
      );
    }
  };

  return (
    <BookInfContext.Provider
      value={{
        dates,
        setDates,
        dateRange,
        setDateRange,
        // rmCnt,
        // setRmCnt,
        items,
        setItems,
        // adltCnt,
        // setAdltCnt,
        // childCnt,
        // setChildCnt,
        promCd,
        setPromCd,
        bkStep,
        setBkStep,
        bookInf,
        // setBookInf,
        isSearch,
        setIsSearch,
        calendarOpen,
        setCalendarOpen,
        userInf,
        setUserInf,
        onBookInf,
        onUserInf,
        onBkStep,
        terms,
        onCheckBox,
      }}
    >
      {children}
    </BookInfContext.Provider>
  );
};

export const useBookInfContext = (): BookInfContextType => {
  const context = useContext(BookInfContext);
  if (!context) {
    throw new Error(
      "useBookInfContext BookInfProvider 내에서만 사용해야 합니다."
    );
  }

  return context;
};
